import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PrivateRoute } from './layout/PrivateRoute';
import { PublicRoute } from './layout/PublicRoute';
import Frame from './layout/Frame';
import Organization from './pages/Orgs/Organization';
import CredMain from './pages/Cred/CredMain';
import { NotFound } from './pages/Cred/NotFound';
import { NoPermission } from './pages/Cred/NoPermission';
import { OuPreSelection } from './pages/Cred/OuPreSelection';
import RedirectAccount from './layout/RedirectAccount';
import { LoginRedirect } from './layout/LoginRedirect';
import Retention from './pages/Retention/Retention';
import { Home } from './pages/Home/Home';
import { Unsubscribe } from '@monorepo/shared';
import { HomeElms } from './config/const';

interface IProps {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
}

function Routing(props: IProps) {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/" element={<Home />} {...props} />
            <Route
              path="/unsubscribe/:status"
              element={<Unsubscribe serverName={HomeElms?.name} />}
              {...props}
            />
          </Route>
          <Route
            path="/login-redirect"
            element={<LoginRedirect />}
            {...props}
          />
          <Route element={<PrivateRoute />}>
            <Route element={<RedirectAccount />}>
              <Route
                path="/organization"
                element={
                  <Frame {...props} hideSideMenu>
                    <Organization />
                  </Frame>
                }
                {...props}
              />
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route element={<RedirectAccount />}>
              <Route
                path="/cred"
                element={
                  <Frame {...props} hideSideMenu>
                    <CredMain />
                  </Frame>
                }
              >
                <Route path="no-permission" element={<NoPermission />} />
                <Route path="*" element={<OuPreSelection />} />
              </Route>
            </Route>
          </Route>
          <Route element={<PrivateRoute />}>
            <Route
              path="/vm-retention"
              element={
                <Frame {...props} hideSideMenu>
                  <Retention />
                </Frame>
              }
              {...props}
            />
          </Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default Routing;
